import { render, staticRenderFns } from "./ManageMyBusiness.vue?vue&type=template&id=16531214&scoped=true&"
import script from "./ManageMyBusiness.vue?vue&type=script&lang=js&"
export * from "./ManageMyBusiness.vue?vue&type=script&lang=js&"
import style0 from "./ManageMyBusiness.vue?vue&type=style&index=0&id=16531214&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16531214",
  null
  
)

export default component.exports